import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'

Vue.use(Vuex)

const emptySearch = {
  user: [],
  community: [],
  post: []
}

const initialState = {
  hasSearched: false,
  searchInput: '',
  searchResult: emptySearch
}

const getters = {
  hasSearched: state => state.hasSearched,
  searchInput: state => state.searchInput,
  searchResult: state => state.searchResult
}

const mutations = {
  searchResult: (state, searchResult) => {
    if (searchResult.type) {
      state.searchResult[searchResult.type] = searchResult.data[searchResult.type]
    } else {
      state.searchResult = searchResult.data
    }
  },
  updateSearchInput: (state, searchInput) => {
    state.searchInput = searchInput
  },
  updateHasSearched: (state, value) => {
    state.hasSearched = value
  }

}

const actions = {
  async search({ commit, state }, payload) {
    const searchInput = state.searchInput.trim()
    if (searchInput.length > 0) {
      commit('updateHasSearched', true)
      commit('updateSearchInput', searchInput)
      let searchResult = await axios.get(`${config.getRootApi()}/search`, {
        params: { searchInput: searchInput, type: payload.type }
      })
      commit('searchResult', { data: searchResult.data, type: payload.type })
    } else {
      commit('updateHasSearched', false)
    }
  },
  resetSearch({ commit }) {
    commit('updateHasSearched', false)
    commit('updateSearchInput', '')
    commit('searchResult', { data: emptySearch })
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
